import type { State } from '@/reducers/types';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { retrieveSpo } from './actions';

const sposAdapter = createEntityAdapter<any>({
  sortComparer: (a, b) => a.id.localeCompare(b.id),
});

interface SposState {
  total: number;
  spoData: any;
  isRegenerated?: boolean;
  title?: string;
}

const initialState = sposAdapter.getInitialState<SposState>({
  total: 0,
  spoData: null,
  isRegenerated: undefined,
  title: undefined,
});

const { name, reducer, actions } = createSlice({
  name: 'spos',
  initialState,
  reducers: {
    setSpoData(state, action) {
      state.spoData = action.payload;
    },
    setIsRegenerated(state, action) {
      state.isRegenerated = action.payload;
    },
    setTitle(state, action) {
      state.title = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(retrieveSpo.fulfilled, (state, action) => {
      if (action.payload && action.payload.type === 'complete') {
        const completeUpdate = action.payload.updates.find(
          (update: any) => update.type === 'chain-success',
        );
        state.spoData = completeUpdate?.output?.output.answer;
      }
    });
  },
});

const { setSpoData, setIsRegenerated, setTitle } = actions;

export { name, reducer, setIsRegenerated, setSpoData, setTitle };

export const selectSpoData = (state: State) => state[name].spoData;
export const selectSpoIsRegenerated = (state: State) => state[name].isRegenerated;
export const selectSpoTitle = (state: State) => state[name].title;
